import Button from 'components/Form/Button';
import React from 'react';

type IProps = {
  onCancel: () => void;
  applyFilter: () => void;
};

export default function FilterMoreOption({ onCancel, applyFilter }: IProps) {
  const resetFilter = () => {
    onCancel();
  };

  return (
    <div className="absolute right-0 top-[40px] w-[400px] bg-white shadow-xl">
      <div className="flex flex-col justify-between">
        <div className="flex flex-col py-3">
          <div className="mt-5 border-b border-[#D9D9D9]" />
        </div>
        <div className="flex flex-col items-center justify-between gap-3 p-3">
          <Button
            variant="secondary"
            label="Cancel"
            size="md"
            className="w-full rounded-md bg-[#7F8B94] text-lg font-bold text-white"
            onClick={resetFilter}
          />
          <Button
            variant="primary"
            size="md"
            className="w-full rounded-3xl"
            label="Apply"
            onClick={() => {
              applyFilter();
              onCancel();
            }}
          />
        </div>
      </div>
    </div>
  );
}
